import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";
import EVENT_CATEGORIES from "./_eventCategories";

const categoryKeys = EVENT_CATEGORIES.map((category) => category.key);

const EventPage = Scrivito.provideObjClass("EventPage", {
  onlyInside: ["EventOverviewPage", "GlobalNewsOverviewPage"],
  attributes: {
    ...defaultPageAttributes,
    date: "datetime",
    endDate: "datetime",
    allDay: "boolean",
    showInOverviewUntil: "date",
    locationName: "html",
    locationDescription: "string",
    locationStreet: "string",
    locationCity: "string",
    locationPostalCode: "string",
    locationCountry: "string",
    locationRegion: "string",
    locationRoom: "string",
    locationUrl: "string",
    postOfficeBoxNumber: "string",
    organizerName: "string",
    organizerUrl: "string",
    image: ["reference", { only: "Image" }],
    description: "html",
    shortDescription: "string",
    body: "widgetlist",
    add: "html",
    category: ["enum", { values: categoryKeys }],
    ...metadataAttributes,
  },
  extractTextAttributes: [
    "body",
    "title",
    "segmentName",
    "locationName",
    "locationStreet",
    "locationCity",
    "locationPostalCode",
    "locationCountry",
    "locationRoom",
    "description",
    "shortDescription",
    "add",
  ],
});

export default EventPage;
